import styled from "styled-components";
import { style as styleConfig } from "config";
const MobileOnly = styled.div `
  @media (${styleConfig.media.desktop}) {
    display: none;
  }
`;
export default MobileOnly;
